import { GenerateMemoryDto, GenerateMemoryResponseDto } from 'shared/interfaces/Memory';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const memoryBaseEndpoint = '/memory';

export const MemoryService = {
  generateMemory: async (generateMemoryDto: GenerateMemoryDto) => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${memoryBaseEndpoint}/generate`,
      data: generateMemoryDto
    });

    return response.data as GenerateMemoryResponseDto;
  }
};
